export const MASTER_ID = 1;
export const ADMIN_ID = 2;
export const OPERATOR_ID = 3;
export const READER_ID = 4;
